import script from "./QRCode.vue?vue&type=script&lang=js"
export * from "./QRCode.vue?vue&type=script&lang=js"

import "./QRCode.vue?vue&type=style&index=0&id=74e533de&scoped=true&lang=css"

import exportComponent from "/Users/balbeer.yadav/Development/lmthrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74e533de"]])

export default __exports__